import { SVGProps } from 'react';

const SvgCancelSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M13.303 3.404a.5.5 0 1 0-.707-.707L8 7.293 3.404 2.697a.5.5 0 1 0-.707.707L7.293 8l-4.596 4.596a.5.5 0 1 0 .707.707L8 8.707l4.596 4.596a.5.5 0 1 0 .707-.707L8.707 8l4.596-4.596Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCancelSmall;
